import { render, staticRenderFns } from "./ViewCards.vue?vue&type=template&id=a1ff4a52&"
import script from "./ViewCards.vue?vue&type=script&lang=js&"
export * from "./ViewCards.vue?vue&type=script&lang=js&"
import style0 from "./ViewCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports